<button class="app-status-tabs__item"
        [class.item-active]="tab.active"
        [class.has-color]="!!tab.color"
        [ngClass]="tab.color"
        (click)="selectTab()">
  {{ tab?.name }}
</button>
